import { useEffect } from 'react';
import {
  ICorporateAccountsResponse,
  ISearchResults,
  useSearchCorporateAccountsByDinerId,
} from 'src/utilities/useSearchHooks';

export type UseSearchCorporateAccountsByDinerIdReturn = {
  searchResults: ISearchResults<ICorporateAccountsResponse>;
};

export const useSearchCorporateAccountsByParentAdmin = (
  parentAdminId: string,
  pageSize: number
): UseSearchCorporateAccountsByDinerIdReturn => {
  const searchResults = useSearchCorporateAccountsByDinerId(parentAdminId, {
    size: pageSize,
  });

  useEffect(() => {
    searchResults.doSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { searchResults };
};
